import { useCallback, useState } from 'react';
import type { ToastKind } from '../../components/Toast';
import { useAsyncData } from '../directory/useAsyncData';
import { t } from '../../lib/i18n';

/**
 * Outlook takvim bağlantısı: durum, bağla, bağlantıyı kes. Entegrasyonlar
 * ekranı ile Ayarlar > Takvim aynı akışı kullanıyor.
 */
export function useOutlook(onNotify: (kind: ToastKind, text: string) => void) {
  const [revision, setRevision] = useState(0);
  const status = useAsyncData(() => window.zabit.getOutlookStatus(), revision);
  const [isBusy, setIsBusy] = useState(false);

  const connect = useCallback(async () => {
    setIsBusy(true);
    try {
      const result = await window.zabit.connectOutlook();
      const account = result.ok && result.profile?.email ? ` · ${result.profile.email}` : '';
      if (result.ok) onNotify('success', t(`Outlook bağlandı${account}.`, `Outlook connected${account}.`));
      else if (result.error !== 'timeout') {
        onNotify('error', t(`Outlook bağlanamadı: ${result.error}`, `Could not connect Outlook: ${result.error}`));
      }
    } finally {
      setIsBusy(false);
      setRevision((value) => value + 1);
    }
  }, [onNotify]);

  const disconnect = useCallback(async () => {
    setIsBusy(true);
    try {
      await window.zabit.disconnectOutlook();
    } finally {
      setIsBusy(false);
      setRevision((value) => value + 1);
    }
  }, []);

  return { data: status.data, isBusy, connect, disconnect };
}
